import http from "../common/http";

/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

// get请求
export default {
  sendCheckCode(params) {
    return http.post("sendCheckCode", params);
  },
  userLogin(params) {
    return http.post("userLogin", params);
  },
  uploadWorks(params) {
    return http.post("uploadWorks", params);
  },
  getMyInfo(params) {
    return http.post("getMyInfo", params);
  },
  delWorks(params) {
    return http.post("delWorks", params);
  },
};



// WEBPACK FOOTER //
// ./src/api/api.js